/*eslint eqeqeq: "off"*/
import * as SignalR from '@microsoft/signalr';
import { rootStore } from 'store';
import './hmiglobal';

import { MnemoAlrmStructure, MnemoParams } from './hooks/CentumVPScript';
import { ParamCVRequest } from './interfaces';

let hostdata: string = window.hostdata; //"/ixyber/base";//"http://localhost:5104";

export let prefbase = ''; //Ивану ""

let connection = new SignalR.HubConnectionBuilder()
    .withUrl(window.hostdata + '/hub/webclients')
    .configureLogging(SignalR.LogLevel.Error)
    .build();

export let Base: any = {};

export let Items: any = {};
export let HisttoryConfig: any = {};
export let LastAlarms: any = {};
export let LoadState: boolean;

export interface CentumVPEvent {
    Messages: any[];
    NoAckCount: 0;
}

export interface IEventsBase {
    ActiveEvents: any[];

    CentumVP: {
        TopNoAck3: any[];
        MnemoAlrm: MnemoAlrmStructure;
        AL: CentumVPEvent;
        SA: CentumVPEvent;
        OG: CentumVPEvent;
    };
}
export let Events: IEventsBase = {
    ActiveEvents: [],
    CentumVP: {
        TopNoAck3: [],
        MnemoAlrm: {},
        AL: {
            Messages: [],
            NoAckCount: 0
        },
        SA: {
            Messages: [],
            NoAckCount: 0
        },
        OG: {
            Messages: [],
            NoAckCount: 0
        }
    }
};

function UpdateParams(key: string, value: any) {
    if (key) {
        let name = key.toUpperCase();
        let names = GetPathAndParam(name);
        let item = Items[names.path];
        if (item == null) {
            Items[names.path] = {};
            item = Items[names.path];
        }

        if (item[names.param] != null) {
            item[names.param] = value;
        } else {
            let keys = Object.keys(item);
            for (let key in keys) {
                if (keys[key].toUpperCase() == names.param) {
                    item[keys[key]] = value;
                    break;
                }
            }
        }
    }
}

export function GetActiveEvents(): IEventsBase {
    return Events;
}

export function AckEvents(ids: string[]) {
    return fetch(hostdata + `/Event/AckEvents`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(ids),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
        })
        .catch((error) => {
            console.log('error', error);
        });
}

export function RemoveEvents(ids: string[]) {
    return fetch(hostdata + `/Event/RemoveEvents`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(ids),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
        })
        .catch((error) => {
            console.log('error', error);
        });
}

export function AckEventsBlock(path: string) {
    return fetch(hostdata + `/Event/AckEventsBlock`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(path),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
        })
        .catch((error) => {
            console.log('error', error);
        });
}

export function ClientRegisterCommands() {
    hostdata = window.hostdata;

    GetDeltaSystemTime();

    if (connection.state !== SignalR.HubConnectionState.Connected) {
        connection.onclose(function () {
            setTimeout(function () {
                Connect();
            }, 1000); // Restart connection after 5 seconds.
        });

        Connect();

        connection.on('SendValues', (_params: any) => {
            for (let [key, value] of Object.entries(_params)) {
                UpdateParams(key, value);
            }
        });

        //икноки для видов алармов
        //Прямоугольник с заливкой
        const rectColor = (blink: boolean, color: string) =>
            `<svg width="13" height="17" xmlns="http://www.w3.org/2000/svg"><rect style="${blink ? 'animation: blink-animation 1s steps(2, start) infinite;' : ''} " width="100%" height="100%" fill="${color}" /></svg>`;
        //Прямоугольник наполовину с заливкой
        const rectColorHalf = (blink: boolean, color: string) =>
            `<svg width="13" height="17" xmlns="http://www.w3.org/2000/svg"><rect style="${blink ? 'animation: blink-animation 1s steps(2, start) infinite;' : ''} " width="100%" height="100%" fill="none" stroke="${color}" stroke-width="5" /></svg>`;

        // const squareColor = (blink:boolean, color:string) => `<div style="width: 15px; height: 15px; background-color: ${color}; transform: rotate(45deg); ${blink ? "animation: blink-animation 1s steps(2, start) infinite;" : ""} "></div>`;
        const squareColor = (blink: boolean, color: string) =>
            `<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <rect style="${blink ? 'animation: blink-animation 1s steps(2, start) infinite;' : ''}" 
                      width="70%" height="70%" fill="${color}" transform="rotate(45) translate(7, -6)" />
            </svg>`;

        connection.on('SendActiveEvents', (events: any[]) => {
            Events.ActiveEvents = events;
            Events.CentumVP.TopNoAck3 = [];
            Events.CentumVP.MnemoAlrm = {};
            Events.CentumVP.AL.NoAckCount = 0;
            Events.CentumVP.AL.Messages = [];
            Events.CentumVP.SA.NoAckCount = 0;
            Events.CentumVP.SA.Messages = [];
            Events.CentumVP.OG.NoAckCount = 0;
            Events.CentumVP.OG.Messages = [];

            const alarmMap = new Map(Object.entries(MnemoParams));

            for (let i = Events.ActiveEvents.length - 1; i >= 0; i--) {
                let aevent = Events.ActiveEvents[i];

                let hasAck = ((aevent.NewState >> 2) & 1) == 1;
                let hasEventOut = ((aevent.InitState >> 0) & 1) == 0; //Recover
                let dateEvent = new Date(aevent.Time);

                let Priority = aevent.Severity;

                let ms: any = {};
                if (aevent.EventCategory == 102) {
                    //AL
                    if (hasAck) Events.CentumVP.AL.NoAckCount++;
                    let color = hasEventOut
                        ? rectColorHalf(hasAck, aevent.Background)
                        : rectColor(hasAck, aevent.Background);

                    ms = {
                        selected: '',
                        id: aevent.ID,
                        NewState: aevent.NewState,
                        indexNumber: Events.CentumVP.AL.Messages.length + 1,
                        alarm: color,
                        date: dateEvent.getMonth() + 1 + '/' + dateEvent.getDate(),
                        time: dateEvent.toLocaleTimeString(),
                        AM: '',
                        folder: aevent.Block,
                        error: aevent.BlockDesc,
                        conditionName: aevent.StatusName,
                        priority: Priority,
                        recover: hasEventOut,
                        eventCategory: aevent.EventCategory
                    };
                    Events.CentumVP.AL.Messages.push(ms);

                    if (Events.CentumVP.TopNoAck3.length < 3 && hasAck) {
                        Events.CentumVP.TopNoAck3.push(ms);
                    }
                } else if (aevent.EventCategory == 101) {
                    //SA
                    if (hasAck) Events.CentumVP.SA.NoAckCount++;
                    let color = squareColor(hasAck, aevent.Background);

                    ms = {
                        selected: '',
                        id: aevent.ID,
                        NewState: aevent.NewState,
                        indexNumber: Events.CentumVP.SA.Messages.length + 1,
                        alarm: color,
                        date: dateEvent.getMonth() + 1 + '/' + dateEvent.getDate(),
                        time: dateEvent.toLocaleTimeString(),
                        AM: '',
                        folder: aevent.Block,
                        error: aevent.BlockDesc,
                        priority: Priority,
                        recover: hasEventOut,
                        eventCategory: aevent.EventCategory
                    };
                    Events.CentumVP.SA.Messages.push(ms);

                    if (Events.CentumVP.TopNoAck3.length < 3 && hasAck) {
                        Events.CentumVP.TopNoAck3.push(ms);
                    }
                } else if (aevent.EventCategory == 105) {
                    // OG
                    if (hasAck) Events.CentumVP.OG.NoAckCount++;
                    let color = rectColor(hasAck, aevent.Background);
                    let error = `<div style="color: ${aevent.Background}">${aevent.BlockDesc}</div>`;

                    ms = {
                        selected: '',
                        id: aevent.ID,
                        NewState: aevent.NewState,
                        indexNumber: Events.CentumVP.OG.Messages.length + 1,
                        alarm: color,
                        date:
                            dateEvent.getMonth() +
                            1 +
                            '/' +
                            dateEvent.getDate() +
                            '  ' +
                            dateEvent.toLocaleTimeString() +
                            error,
                        AM: '',
                        folder: aevent.Block,
                        bacgroundColor: aevent.Background
                    };
                    Events.CentumVP.OG.Messages.push(ms);
                }

                if (alarmMap.size !== 0) {
                    for (let [key, value] of alarmMap) {
                        if (!Events.CentumVP.MnemoAlrm[key]) {
                            Events.CentumVP.MnemoAlrm[key] = {
                                Alarms: [],
                                Top: []
                            };
                        }

                        if (new Set(value.Alarms).has(aevent.Block)) {
                            const ms = {
                                id: aevent.ID,
                                NewState: aevent.NewState,
                                hasAck: hasAck,
                                folder: aevent.Block,
                                Background: aevent.Background,
                                Severity: aevent.Severity
                            };

                            Events.CentumVP.MnemoAlrm[key].Alarms.push(ms);

                            if (Events.CentumVP.MnemoAlrm[key].Top.length < 1) {
                                Events.CentumVP.MnemoAlrm[key].Top.push(ms);
                            } else if (!Events.CentumVP.MnemoAlrm[key].Top[0].hasAck && hasAck) {
                                Events.CentumVP.MnemoAlrm[key].Top[0] = ms;
                            } else if (
                                Events.CentumVP.MnemoAlrm[key].Top[0].Severity < aevent.Severity &&
                                (!Events.CentumVP.MnemoAlrm[key].Top[0].hasAck || hasAck)
                            ) {
                                Events.CentumVP.MnemoAlrm[key].Top[0] = ms;
                            }
                        }
                    }
                }
            }
            Events.CentumVP;
        });

        connection.on('SendEvents', (_params: any) => {
            //console.log(_params);
        });

        connection.on('SendMessages', (messages: any) => {
            //console.log(messages);
        });
    }
}

function Connect() {
    fetch(hostdata + '/Base/GetBase')
        .then((res) => res.json())
        .then(
            (result) => {
                if (connection.state == SignalR.HubConnectionState.Disconnected) connection.start();

                Base = result;

                prefbase = Base.name;

                CreateItemAndCreateNewParam(Base);

                LoadState = true;
            },
            // Примечание: важно обрабатывать ошибки именно здесь, а не в блоке catch(),
            // чтобы не перехватывать исключения из ошибок в самих компонентах.
            (error) => {
                setTimeout(Connect, 5000);

                LoadState = true;
            }
        );
}

export const GetVerGuid = async () => {
    try {
        const response = await fetch(hostdata + '/base/verGuid');
        if (!response.ok) {
            throw await response.json();
        }
        return response.text();
    } catch (error: any) {
        throw error || { message: 'Failed to fetch guid' };
    }
};

function CreateItemAndCreateNewParam(blocks: any) {
    let path = blocks.path;

    if (path != null) {
        path = path.toUpperCase();
        Items[path] = blocks;

        let parentpath: string = '';
        if (path.lastIndexOf('.') != -1) {
            parentpath = path.substring(0, path.lastIndexOf('.'));
        } else {
            parentpath = path.substring(0, path.lastIndexOf('/'));
        }
        blocks.parent = Items[parentpath];
    }

    for (let key in blocks) {
        if (key != 'parent') {
            if (blocks[key] instanceof Object) {
                CreateItemAndCreateNewParam(blocks[key]);
            }
        }
    }
}

interface Param {
    N: string;
    V: any;
    T?: Date;
    Q?: number;
    Value?: any;
    Type: string;
}

interface PathAndParam {
    path: string;
    param: string;
    fullname: string;
}

export function GetPathAndParam(key: string): PathAndParam {
    key = key.toUpperCase();

    let indexDot = key.lastIndexOf('.');

    if (key.indexOf(prefbase + '/') != 0 && key.indexOf(prefbase + '.') != -0) {
        let t_key = indexDot != -1 ? key.substring(0, indexDot) : key;
        if (Items[prefbase + '/' + t_key] != null) {
            key = prefbase + '/' + key;
        } else if (Items[prefbase + '/DCS/' + t_key] != null) {
            /// ДЛЯ DCS экранов
            key = prefbase + '/DCS/' + key;
        } else if (Items[prefbase + '/XD/AVT/' + t_key] != null) {
            key = prefbase + '/XD/AVT/' + key;
        }
    }

    indexDot = key.lastIndexOf('.');

    let pathstr = key;
    let paramstr = '';

    if (Items[key]?.hasOwnProperty('CV')) {
        paramstr = 'CV';
    } else if (indexDot != -1) {
        pathstr = key.substring(0, indexDot);
        paramstr = key.substring(indexDot + 1);
    }

    return {
        path: pathstr,
        param: paramstr,
        fullname: pathstr + '.' + paramstr
    };
}

export function GetParam(name: string): Param {
    let param: Param = { N: name, V: 'null', T: window.SystemDate(), Q: 0, Type: '' };
    name = name.toUpperCase();

    let names = GetPathAndParam(name);
    let item = Items[names.path];
    let val = 'null';
    if (item != null) {
        if (item[names.param] != null) {
            val = item[names.param];
        } else {
            let keys = Object.keys(item);
            for (let key in keys) {
                if (keys[key].toUpperCase() == names.param) {
                    val = item[keys[key]];
                    break;
                }
            }
        }

        if (names.param == 'CV') {
            if (item['time'] != 'null') {
                param.T = new Date(item['time']);
            }

            if (item['quality'] != 'null') {
                param.Q = Number(item['quality']);
            }

            if (item['type'] != 'null') {
                param.Type = item['type'];
            }
        } else {
            param.Type = typeof val;
        }
    } else {
        val = param.N;
        param.Q = 0x80330000;
    }

    param.V = val;
    param.Value = param.V;

    return param;
}

let itemsBuffer: Map<string, object> = new Map<string, object>();
let writingInterval = 20;

function writeItems() {
    if (itemsBuffer.size !== 0) {
        SetParamBase(Array.from(itemsBuffer.entries()).map(([name, value]) => ({ name, value })));
        itemsBuffer.clear();
    } else {
        setTimeout(writeItems, writingInterval);
    }
}

writeItems();

export function SetParam(name: string, value: any) {
    itemsBuffer.set(name, value);
}

let numberTypes: string[] = [
    'number',
    'short',
    'ushort',
    'int',
    'uint',
    'long',
    'ulong',
    'nint',
    'nuint',
    'float',
    'double',
    'decimal'
];

export function SetParamBase(dataArray: any) {
    if (!Array.isArray(dataArray)) {
        // console.error('SetParamBase: dataArray must be an array');
        return;
    }

    function isValidJSON(jsonString: string) {
        try {
            JSON.parse(jsonString);
        } catch (e) {
            return false;
        }
        return true;
    }

    const processedData = dataArray.map((data) => {
        if (data.value == null) {
            return;
        }

        let name = data.name ? data.name.toUpperCase() : data.item.toUpperCase();
        let pathAndParam = GetPathAndParam(name);
        let typeParam = GetParam(name).Type;

        if (!typeParam.includes('[]')) {
            if (
                numberTypes.indexOf(typeParam) != -1 ||
                typeParam.indexOf('Enum') != -1 ||
                ((typeParam == '' || typeParam == 'object') && isNaN(Number(data.value)))
            ) {
                const convertedValue = Number(data.value.toString().replace(',', '.'));

                if (!isNaN(convertedValue)) {
                    data.value = convertedValue;
                } else {
                    data.value = data.value.toString();
                }

                if (data.value == null) {
                    return;
                }
            }
        }
        let valueToProcess = isValidJSON(data.value) ? JSON.parse(data.value) : data.value;
        return {
            item: pathAndParam.fullname,
            value: JSON.stringify(valueToProcess)
        };
    });

    let request = new XMLHttpRequest();
    request.open('POST', hostdata + `/SystemApi/ChangePropertyPaths`, true);
    request.setRequestHeader('Authorization', `Bearer ${rootStore.AuthStore.token}`);
    request.setRequestHeader('Accept', 'application/json');
    request.setRequestHeader('Content-Type', 'application/json');
    try {
        request.send(JSON.stringify(processedData));
    } catch (err) {
        rootStore.ErrorStore.message = request.status.toString();
    }
    request.onload = function () {
        if (request.status) {
            setTimeout(writeItems, writingInterval);
        }
        if (request.status != 200) {
            rootStore.ErrorStore.message = 'Error Code: ' + request.status.toString();
        }
    };
}

export function SetParamBaseCentum(data: any): Promise<void> {
    return new Promise((resolve, reject) => {
        if (!Array.isArray(data)) {
            reject(new Error('dataArray must be an array'));
            return;
        }

        let request = new XMLHttpRequest();
        request.open('POST', hostdata + `/SystemApi/ChangePropertyPaths`, true);
        request.setRequestHeader('Authorization', `Bearer ${rootStore.AuthStore.token}`);
        request.setRequestHeader('Accept', 'application/json');
        request.setRequestHeader('Content-Type', 'application/json');

        request.onload = function () {
            if (request.status == 200) {
                resolve();
            } else {
                reject(new Error(`Request failed with status ${request.status}`));
            }
        };

        request.onerror = function () {
            reject(new Error('Network error occurred'));
        };

        try {
            request.send(JSON.stringify(data));
        } catch (err) {
            reject(err);
        }
    });
}

export async function GetItemList(query: string = '', attributeQueries: any = null): Promise<string[]> {
    let res = []; //ListItem;
    if (query != '' || attributeQueries != null) {
        for (let itemname in Items) {
            let index = itemname.toUpperCase().indexOf(query.toUpperCase());

            if (index != -1) {
                let onrequest = true;
                for (let attrname in attributeQueries) {
                    let findvalue = attributeQueries[attrname];
                    let paramvalue = Items[itemname][attrname];
                    if (paramvalue == null) paramvalue = '';

                    if (findvalue != null) {
                        index = paramvalue.toUpperCase().indexOf(findvalue.toUpperCase());
                        if (index == -1) {
                            onrequest = false;
                            break;
                        }
                    }
                }

                if (onrequest) res.push(itemname);
            }
        }
    }
    return res;
}

export function GetParamsItems(ids: string[]): any[] {
    let res: any = [];
    for (let i = 0; i < ids.length; i++) {
        let params = GetParamsValue(ids[i]);
        res.push(params);
    }
    return res;
}

export function GetParamsValue(item: string): string[] {
    let res: any = {};
    item = item.toUpperCase();
    for (let key in Items[item]) {
        if (!(Items[item][key] instanceof Object)) {
            res[key] = Items[item][key];
        }
    }
    return res;
}

export function GetParamsItem(item: string): string[] {
    let res: string[] = [];
    item = item.toUpperCase();
    for (let key in Items[item]) {
        if (!(Items[item][key] instanceof Object)) {
            res.push(key);
        }
    }
    return res;
}

export function GetItem(item: string): any {
    let names = GetPathAndParam(item);
    return Items[names.path.toUpperCase()];
}

export function SubItems(items: string[]) {}

export function UnSubItems(items: string[]) {}

function GetDeltaSystemTime() {
    window.DeltaTimeCurAndSys = 0;
    fetch(hostdata + `/Base/GetCurrentTime`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .then((date) => {
            let ttt = date.replace(/"/gi, '');
            let deltaCurAndSys = Date.now() - Date.parse(ttt);
            if (deltaCurAndSys > 600000) {
                alert('Разница между текущим временем и серверным, более 1 минуты!');
            }
            window.DeltaTimeCurAndSys = deltaCurAndSys;
        })
        .catch((error) => {
            console.log('error', error);
        });
}

export interface BaseEventType {
    id: string;
    eventType: number;
    eventCategory: number;
    sourceName: string;
    time: string;
    message: string;
    classMessage: string;
    severity: number;
    block: string;
    param: string;
    station: string;
    cookie: number;
    sourceSystem: string;
    namespace: string;
    application: string;
    attr1: string;
    attr2: string;
    conditionName: string;
    clientUserId: string;
    newState: number;
    clientUserFullName: string;
    clientAuditEntryId: string;
    prevValue: string;
    value: string;
    EU: string;
}

export function GetBase() {
    return Base;
}

export function GetObject(name: string) {
    if (name == null) {
        return Base;
    }

    name = name.toUpperCase();
    if (Items[name]) {
        return Items[name];
    }

    return {};
}

export const UpdateObject = async (name: string) => {
    if (name == null) {
        return Base;
    }

    name = name.toUpperCase();
    if (Items[name]) {
        try {
            const obj = await SettingsGetObject(Items[name].id);
            CreateItemAndCreateNewParam(obj);
            return obj;
        } catch (error) {
            console.log('error', error);
            return {};
        }
    }

    return {};
};

export function DownloadPDF(url: string, framename: string = '', fileName: string = '') {
    let formData = new FormData();

    formData.append('url', url);
    formData.append('frameName', framename);

    if (fileName == '' || fileName == null) {
        fileName = 'Report';
    }

    //let hostdata1 = "http://localhost:5050";
    fetch(hostdata + `/ConvertFile/GetUrlVisiontoPdf`, {
        method: 'POST',
        cache: 'no-cache',
        body: formData
    })
        .then((response) => response.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + `.pdf`);

            document.body.appendChild(link);
            link.click();
            if (link.parentNode) link.parentNode.removeChild(link);
        })
        .catch((error) => {
            console.log('error', error);
        });
}

export function ScriptServerRunPyAsync(scriptname: string, args: object) {
    let formData = new FormData();

    formData.append('scriptname', scriptname);
    formData.append('args', JSON.stringify(args));

    const asString = new URLSearchParams(formData as any).toString();

    return fetch(hostdata + `/Script/Py?` + asString, {
        method: 'GET'
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function ScriptServerSaveJsonFile(jsonObj: string, fileName: string) {
    let formData = new FormData();

    formData.append('jsonObj', jsonObj);
    formData.append('fileName', fileName);

    return fetch(hostdata + `/SystemApi/SaveJsonFile`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return error;
        });
}

export function SetParamCV(data: ParamCVRequest[]): Promise<boolean> {
    const newData = JSON.stringify(data);

    return fetch(hostdata + '/SystemApi/SetParamCV', {
        method: 'POST',
        cache: 'no-cache',
        body: newData,
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            return response.json();
        })
        .then(() => {
            return true;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}

export function ScriptServerReadJsonFile(fileName: string) {
    let formData = new FormData();

    formData.append('fileName', fileName);

    const asString = new URLSearchParams(formData as any).toString();

    return fetch(hostdata + `/SystemApi/ReadJsonFile?` + asString, {
        method: 'GET',
        cache: 'no-cache',
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return error;
        });
}

export function SettingsChangeProperty(id: string, propName: string, value: any) {
    let formData = new FormData();

    formData.append('id', id);
    formData.append('property', propName);
    formData.append('value', JSON.stringify(value)); //JSON.stringify(value.toString())

    return fetch(hostdata + `/SystemApi/ChangeProperty`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return {};
        });
}

export function TemplateGetBinding(name: string) {
    return fetch(hostdata + `/SystemApi/GetBindingsTemplate?name=` + name)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function CreateObjectTemplate(name: string, TypeName: string, idParent: string, bindingValue: string) {
    let formData = new FormData();

    formData.append('name', name);
    formData.append('TypeName', TypeName);
    formData.append('idParent', idParent);
    formData.append('bindingValue', bindingValue);

    return fetch(hostdata + `/SystemApi/CreateObjectTemplate`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return {};
        });
}

export function SettingsGetObjectDto(id?: string) {
    let param = id ? `?id=${id}` : '';
    return fetch(hostdata + `/SystemApi/GetObjectDto` + param)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsGetObject(id?: string) {
    let param = id ? `?id=${id}` : '';
    return fetch(hostdata + `/SystemApi/GetObject` + param)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsGetObjectsDto(ids?: string[]) {
    const param = ids ? `?ids=${ids.join(',')}` : '';
    return fetch(hostdata + `/SystemApi/GetObjectsDto` + param)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsGetChildTypes(id?: string) {
    let param = id ? `?id=${id}` : '';
    return fetch(hostdata + `/SystemApi/GetChildTypes` + param)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export async function SettingsGetType(id?: string) {
    let url = id ? 'classnames=' + encodeURIComponent(id) : '';
    return await fetch(hostdata + `/SystemApi/GetDataSchemaOnClassName?` + url)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsGetPathsType(typestr?: string) {
    let url = typestr ? 'typestr=' + encodeURIComponent(typestr) : '';
    return fetch(hostdata + `/SystemApi/GetPathsType?` + url)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsGetTypesWithProperties(id?: string) {
    let param = id ? `?id=${id}` : '';
    return fetch(hostdata + `/SystemApi/GetTypesWithProperties` + param)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsCreateObject(name: string, TypeName: string, idParent: string, typeStyle: string) {
    let formData = new FormData();

    formData.append('name', name);
    formData.append('TypeName', TypeName);
    formData.append('idParent', idParent);
    formData.append('typeStyle', typeStyle);

    return fetch(hostdata + `/SystemApi/CreateObject`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return {};
        });
}
export function SettingsUpdateBase() {
    return fetch(hostdata + `/SystemApi/UpdateBase`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (response.status == 200) return 'true';
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function PasteObject(id: string, idParent: string) {
    let formData = new FormData();
    formData.append('id', id);
    formData.append('idParent', idParent);

    return fetch(hostdata + `/SystemApi/PasteObject`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            let text = response.text();

            Connect();

            return text;
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function CopyObject(name: string, id: string, idParent: string, bindingValue: string) {
    let formData = new FormData();

    formData.append('name', name);
    formData.append('id', id);
    formData.append('idParent', idParent);
    formData.append('bindingValue', bindingValue);

    return fetch(hostdata + `/SystemApi/CopyObject`, {
        method: 'POST',
        cache: 'no-cache',
        body: JSON.stringify(Object.fromEntries(formData)),
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function SettingsDeleteObject(id: string, delete_all: boolean = false) {
    return fetch(hostdata + `/SystemApi/RemoveObject?id=${id}&delete_all=${delete_all}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return '';
        });
}

export function SettingsGetIdsObjects(objAttributes: object) {
    return fetch(hostdata + `/SystemApi/GetIdsObjects`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(objAttributes)
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function SettingsMethodInvoke(id: string, name: string, args?: string[]) {
    let formData = new FormData();

    let str = args ? args : [];

    formData.append('args ', JSON.stringify(str));

    return fetch(hostdata + `/SystemApi/MethodInvoke?id=${id}&name=${name}`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            Authorization: `Bearer ${rootStore.AuthStore.token}`,
            'Content-Type': 'application/json'
        },
        body: formData
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return {};
        });
}
export function SettingsGetIsLoaded() {
    return fetch(hostdata + `/SystemApi/IsLoaded`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return false;
        });
}

// Easy Settings
export function EasySettingsGetUnits() {
    return fetch(hostdata + `/SettingsFiles/Units`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function EasySettingsSetUnits(obj: object) {
    return fetch(hostdata + `/SettingsFiles/Units`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(obj)
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            rootStore.ErrorStore.message = error.toString();
            return {};
        });
}
export function EasySettingsGetTemplates() {
    return fetch(hostdata + `/SettingsFiles/Templates`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function EasySettingsSetTemplates(str: string) {
    return fetch(hostdata + `/SettingsFiles/Templates`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(str)
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function EasySettingsGetNamedSets() {
    return fetch(hostdata + `/SettingsFiles/NamedSets`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function EasySettingsSetNamedSets(obj: object) {
    return fetch(hostdata + `/SettingsFiles/NamedSets`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: JSON.stringify(obj)
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function EasySettingsGetScripts() {
    return fetch(hostdata + `/SettingsFiles/GetScipts`)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}
export function EasySettingsGetScript(name: string) {
    return fetch(hostdata + `/SettingsFiles/GetSript?name=` + name)
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.text();
        })
        .catch((error) => {
            console.log('error', error);
            return '';
        });
}
export function EasySettingsSetScripts(name: string, obj: object) {
    let formData = new FormData();
    formData.append('name ', name);
    formData.append('contents ', JSON.stringify(obj));

    return fetch(hostdata + `/SettingsFiles/SetScript`, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        body: formData
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export function ExportObject(
    id: string,
    separator: string,
    namesToSend: any[],
    typesToSend: any[],
    isExportAll: boolean
) {
    let formData = new FormData();

    formData.append('id', id);
    formData.append('separator', separator);

    if (namesToSend) {
        namesToSend.forEach((name, index) => {
            formData.append(`name[${index}]`, name);
        });
    }

    if (typesToSend) {
        typesToSend.forEach((type, index) => {
            formData.append(`type[${index}]`, type);
        });
    }

    formData.append('isExportAll', `${isExportAll}`);

    const asString = new URLSearchParams(formData as any).toString();

    return fetch(hostdata + `/Export/block?` + asString, {
        method: 'GET',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
            Authorization: `Bearer ${rootStore.AuthStore.token}`
        }
    })
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.blob();
        })
        .then((blobfile) => {
            var link = document.createElement('a'),
                filename = 'blocks.csv';
            link.href = URL.createObjectURL(blobfile);
            link.download = filename;
            link.click();
            return {};
        })
        .catch((error) => {
            console.log('error', error);
            return {};
        });
}

export interface importData {
    separator: string;
    filecsv?: any;
}

export function ImportObject(id: string, data: importData): Promise<ResponseImport> {
    if (data.filecsv) {
        const formData = new FormData();
        formData.append('id', id);
        formData.append('csv', data.filecsv, 'object.csv');
        formData.append('separator', data.separator);

        return fetch(hostdata + `/Import/block`, {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                Authorization: `Bearer ${rootStore.AuthStore.token}`
            },
            body: formData
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);
                return response.text();
            })
            .then((responseData: string) => {
                try {
                    const parsedResponse = JSON.parse(responseData);
                    return parsedResponse;
                } catch (error) {
                    console.error('Ошибка при парсинге ответа:', error);
                    throw new Error('Невозможно обработать ответ от сервера');
                }
            })
            .catch((error) => {
                console.error('Ошибка импорта:', error);
                throw error;
            });
    } else {
        throw new Error('Файл CSV не предоставлен');
    }
}

export interface ResponseImport {
    Message: string;
    SuccessAddedCount: number;
    IsSuccessImport: boolean;
}
